export default "__VITE_ASSET__Ig82EEWc__"